import { useState, useMemo } from "react";

export function useSearch(users) {
  const [searchValue, setSearchValue] = useState("");

  const filteredUsers = useMemo(() => {
    if (!users) return {};

    const lowered = searchValue.toLowerCase();

    return Object.entries(users).reduce((acc, [orgName, userList]) => {
      const matchedUsers = userList.filter((user) => {
        return (
          user.lastName.toLowerCase().includes(lowered) ||
          user.firstName.toLowerCase().includes(lowered)
        );
      });

      if (matchedUsers.length > 0) {
        acc[orgName] = matchedUsers;
      }
      return acc;
    }, {});
  }, [users, searchValue]);

  return { searchValue, setSearchValue, filteredUsers };
}
